import type { AxiosRequestConfig } from "axios";

import { logger } from "../../logging/logger";
import type { Interceptor } from "./interceptor";
import { describeRequest, markRequestStart, summarizeBody, summarizeHeaders } from "./net-log";
import { isLoggedUrl, netLogConfig } from "./net-log-config";

export const addRequestLogInterceptor: () => Interceptor<AxiosRequestConfig> = () => ({
  onFulfilled: async (config) => {
    markRequestStart(config);

    if (!netLogConfig.requests || !isLoggedUrl(config.url)) {
      return config;
    }

    const parts: string[] = ["HTTP →", describeRequest(config)];
    if (netLogConfig.headers) {
      parts.push(`headers: ${summarizeHeaders(config.headers)}`);
    }
    if (netLogConfig.requestBody) {
      parts.push(`body: ${summarizeBody(config.data)}`);
    }
    logger.info(...parts);

    return config;
  },
});
